export default __webpack_public_path__ + "static/media/CDC_pt.a321313f.svg";